import axios from "axios";
import { BASE_URL } from "./feedApi";

// Content preferences: the reader's Preferred Languages / Categories and the
// writer's default writing language. The server owns the supported lists
// (Server/config/contentConfig.js) and validates every value; the copy below
// is only a fallback so a form can still render if that request fails.
export const FALLBACK_OPTIONS = {
  languages: ["English", "Hindi", "Telugu", "Kannada", "Tamil", "Malayalam", "Marathi", "Bengali"],
  categories: [
    "Technology", "Programming", "Education", "Business", "Finance", "Travel",
    "Food", "Sports", "Entertainment", "Lifestyle", "Science",
  ],
};

const EMPTY = {
  preferredLanguages: [],
  preferredCategories: [],
  defaultWritingLanguage: "",
  options: FALLBACK_OPTIONS,
};

function authConfig() {
  const token = localStorage.getItem("token");
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

// Always resolves to a well-formed object, so callers never have to guard
// against a partial response.
const normalise = (data) => ({
  preferredLanguages: Array.isArray(data?.preferredLanguages) ? data.preferredLanguages : [],
  preferredCategories: Array.isArray(data?.preferredCategories) ? data.preferredCategories : [],
  defaultWritingLanguage: typeof data?.defaultWritingLanguage === "string" ? data.defaultWritingLanguage : "",
  options: {
    languages: Array.isArray(data?.options?.languages) && data.options.languages.length
      ? data.options.languages
      : FALLBACK_OPTIONS.languages,
    categories: Array.isArray(data?.options?.categories) && data.options.categories.length
      ? data.options.categories
      : FALLBACK_OPTIONS.categories,
  },
});

export async function getContentPreferences() {
  const res = await axios.get(`${BASE_URL}/api/user/content-preferences`, authConfig());
  return normalise(res.data || EMPTY);
}

// Send only the fields being changed; the server leaves the others alone.
export async function saveContentPreferences(changes) {
  const res = await axios.put(`${BASE_URL}/api/user/content-preferences`, changes, authConfig());
  return normalise(res.data || EMPTY);
}
